import { useActivitiesContext } from '../../../context'
import { useMemo } from 'react'
import { ActivityDetails, ActivityStatus } from '@user/features/Activity'
import { ActivitiesHelper } from '@user/features/Activity/helpers'

function getOverdueActivities(
  activities: ActivityDetails[],
): ActivityDetails[] {
  return activities.filter(ActivitiesHelper.isOverdueActivity)
}

export function useData() {
  const [{ activities }] = useActivitiesContext()
  const overdueActivities = useMemo(
    () => getOverdueActivities(activities),
    [activities],
  )

  const badgeColor = useMemo(
    (): 'primary' | 'error' =>
      !!overdueActivities.length ? 'error' : 'primary',
    [overdueActivities],
  )

  const badgeContent = useMemo(
    () => (!!overdueActivities.length ? overdueActivities.length : ''),
    [overdueActivities],
  )

  const showBadge = useMemo(
    () =>
      !!activities.filter(
        (activity) =>
          activity.status === ActivityStatus.Todo ||
          activity.status === ActivityStatus.InProgress,
      ).length,
    [activities],
  )

  return {
    badgeContent,
    badgeColor,
    activities,
    showBadge,
  }
}
